<template>
  <section class="product-materials">
    <header>
      <h2>{{material.title}}</h2>
      <p class="subtitle">
        {{material.subtitle}}
      </p>
    </header>
    <div class="container material-en">
      <div class="material-row">
        <div class="material-row__photo">
          <img v-lazy="require('../../../static/images/product/hardcover-en.png')" alt="Hardcover">
        </div>
        <div class="material-row__info">
          <div class="material-row__badge">{{ $t('products.materialHardcover') }}</div>
          <p class="material-row__slogan">{{ $t('products.materialHardcoverSlogan') }}</p>
          <div class="material-row__details">
            <div class="material-row__detail">
              <h4>{{ $t('products.materialInnerPaper') }}</h4>
              <p>{{ $t('products.materialHardPaper') }}</p>
              <p>{{ $t('products.materialHardSize') }}</p>
            </div>
            <div class="material-row__detail">
              <h4>{{ $t('products.materialBinding') }}</h4>
              <p>{{ $t('products.materialHardOuter') }}</p>
              <p>{{ $t('products.materialHardInner') }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="material-row">
        <div class="material-row__photo">
          <img v-lazy="require('../../../static/images/product/softcover-en.png')" alt="Paperback">
        </div>
        <div class="material-row__info">
          <div class="material-row__badge">{{ $t('products.materialPaperback') }}</div>
          <p class="material-row__slogan">{{ $t('products.materialPaperbackSlogan') }}</p>
          <div class="material-row__details">
            <div class="material-row__detail">
              <h4>{{ $t('products.materialInnerPaper') }}</h4>
              <p>{{ $t('products.materialSoftPaper') }}</p>
              <p>{{ $t('products.materialSoftSize') }}</p>
            </div>
            <div class="material-row__detail">
              <h4>{{ $t('products.materialBinding') }}</h4>
              <p>{{ $t('products.materialSoftOuter') }}</p>
              <p>{{ $t('products.materialSoftInner') }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ProductMaterials',
  props: {
    material: Object
  },
  computed: {
    ...mapGetters(['language']),
    isEn () {
      return this.language === 'en'
    }
  }
}
</script>

<style lang="scss">
@import '../../styles/variables';
.product-materials {
  img + img {
    margin-top: 1.5rem;
  }

  .material-en {
    max-width: 1100px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 2.5rem;
    // Break out of narrow .container
    width: 100vw;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    padding: 0 2rem;
    box-sizing: border-box;
  }

  .material-row {
    display: flex;
    align-items: center;
    background: #f8f9fc;
    border-radius: 16px;
    overflow: hidden;
    gap: 0;

    &:nth-child(even) {
      flex-direction: row-reverse;

      .material-row__info {
        padding: 2rem 0 2rem 2rem;
      }
    }

    &__photo {
      flex: 0 0 50%;
      text-align: center;
      overflow: hidden;
      border-radius: 12px;

      img {
        width: 100%;
        height: 100%;
        max-height: 420px;
        object-fit: cover;
      }
    }

    &__info {
      flex: 1;
      padding: 2rem 2rem 2rem 2rem;
    }

    &__badge {
      display: inline-block;
      background: $el-color-primary;
      color: #fff;
      font-size: 1.125rem;
      font-weight: 700;
      padding: 0.5rem 1.5rem;
      border-radius: 100px;
      margin-bottom: 0.75rem;
    }

    &__slogan {
      font-size: 1rem;
      color: #6b7280;
      margin-bottom: 1.5rem;
    }

    &__details {
      display: flex;
      gap: 2rem;
    }

    &__detail {
      flex: 1;

      h4 {
        font-size: 0.9375rem;
        font-weight: 600;
        color: #1a1a2e;
        margin-bottom: 0.5rem;
      }

      p {
        font-size: 0.8125rem;
        color: #6b7280;
        margin: 0;
        line-height: 1.6;
      }
    }
  }
}

@media (max-width: 768px) {
  .product-materials {
    .material-row {
      flex-direction: column !important;

      &__photo {
        flex: none;
        padding: 1.5rem 1.5rem 0;
      }

      &__info {
        padding: 1.5rem;
      }

      &__details {
        flex-direction: column;
        gap: 1rem;
      }
    }
  }
}
</style>
